import type { SelectFilterState } from '../../../../../common/constants/filters/select-filter/types';
import { getInvalidDateRange } from '../../../../../common/utils/filters';

const isIsoDate = (str?: string) => {
	if (!str) {
		return false;
	}
	if (!/\d{4}-\d{2}-\d{2}/.test(str)) {
		return false;
	}
	const d = new Date(str);
	return !isNaN(d.getTime());
};

export type CustomValueParserReturnType =
	| {
			to: string;
			from: string;
	  }
	| undefined;

export const customValueParser = (
	queryParams: Record<string, string[] | undefined>,
): CustomValueParserReturnType => {
	const { to, from } = queryParams;
	const isToDateValid = isIsoDate(to?.[0]);
	const isFromDateValid = isIsoDate(from?.[0]);
	const toDate = isToDateValid && to?.[0] ? to?.[0] : '';
	const fromDate = isFromDateValid && from?.[0] ? from?.[0] : '';
	const invalidDateRange = getInvalidDateRange(fromDate, toDate);
	if (!invalidDateRange) {
		return { to: toDate, from: fromDate };
	}
};

export const generateQueryParamsGetState = <ID extends string>(
	initialState: SelectFilterState<ID>,
	queryParamKey: string,
) => {
	return (queryParams: Record<string, string[]>): SelectFilterState<ID> => {
		const queryParamValue = queryParams[queryParamKey];

		let value: string[] | undefined;
		let customValue: CustomValueParserReturnType | undefined;

		if (Array.isArray(queryParamValue)) {
			value = queryParamValue;

			if (queryParamValue[0] === 'custom') {
				customValue = customValueParser(queryParams);
			}
		}

		return {
			...initialState,
			value: value || initialState.value,
			customValue: customValue || initialState.customValue,
		};
	};
};
